module.exports = __webpack_public_path__ + "assets/img/peo2.9703f81e.png";